(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-active-filters"] && !Shopify.designMode) return;
  try {
    (function () {
  const form = document.querySelector('[data-filter-form]');
  if (!form) return;

  // URL hydration is removed for checkboxes because Shopify natively handles `filter_value.active` server-side now.

  // ----- Price slider -----
  const priceRange = form.querySelector('[data-price-range]');
  if (priceRange) {
    const min = parseFloat(priceRange.dataset.priceMin);
    const max = parseFloat(priceRange.dataset.priceMax);
    const handleMin = priceRange.querySelector('[data-price-handle="min"]');
    const handleMax = priceRange.querySelector('[data-price-handle="max"]');
    const inputMin = priceRange.querySelector('[data-price-input="min"]');
    const inputMax = priceRange.querySelector('[data-price-input="max"]');
    const fill = priceRange.querySelector('[data-price-fill]');

    const updateFill = () => {
      const lo = ((parseFloat(handleMin.value) - min) / (max - min)) * 100 || 0;
      const hi = ((parseFloat(handleMax.value) - min) / (max - min)) * 100 || 100;
      fill.style.left = lo + '%';
      fill.style.right = (100 - hi) + '%';
    };

    const syncFromHandles = () => {
      let lo = parseFloat(handleMin.value);
      let hi = parseFloat(handleMax.value);
      if (lo > hi) { [lo, hi] = [hi, lo]; handleMin.value = lo; handleMax.value = hi; }
      inputMin.value = lo;
      inputMax.value = hi;
      updateFill();
    };

    const syncFromInputs = () => {
      let lo = parseFloat(inputMin.value);
      let hi = parseFloat(inputMax.value);
      if (isNaN(lo)) lo = min;
      if (isNaN(hi)) hi = max;
      lo = Math.max(min, Math.min(lo, max));
      hi = Math.max(min, Math.min(hi, max));
      if (lo > hi) [lo, hi] = [hi, lo];
      handleMin.value = lo;
      handleMax.value = hi;
      inputMin.value = lo;
      inputMax.value = hi;
      updateFill();
    };

    handleMin.addEventListener('input', syncFromHandles);
    handleMax.addEventListener('input', syncFromHandles);
    inputMin.addEventListener('change', syncFromInputs);
    inputMax.addEventListener('change', syncFromInputs);
    
    // Set initial load state
    updateFill();

    // Strip default/max values on submit so the URL stays clean
    form.addEventListener('submit', () => {
      if (parseFloat(inputMin.value) <= min) inputMin.removeAttribute('name');
      if (parseFloat(inputMax.value) >= max) inputMax.removeAttribute('name');
    });
  }

  // ----- Mobile close button (drawer) -----
  const closeBtn = form.querySelector('[data-filter-close]');
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      document.dispatchEvent(new CustomEvent('filters:close'));
    });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    const sizeGuideCache = { html: null, promise: null };

    function fetchSizeGuideContent() {
      if (sizeGuideCache.promise) return sizeGuideCache.promise;
      sizeGuideCache.promise = fetch('/pages/size-guide')
        .then((response) => response.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const main = doc.querySelector('main') || doc.body;
          sizeGuideCache.html = main.innerHTML;
          return sizeGuideCache.html;
        })
        .catch(() => {
          sizeGuideCache.html =
            '<p>Sorry, the size guide could not be loaded. <a href="/pages/size-guide">View size guide</a></p>';
          return sizeGuideCache.html;
        });
      return sizeGuideCache.promise;
    }

    function openSizeGuideDrawer(dialog) {
      const content = dialog.querySelector('[data-size-guide-content]');
      if (content && !content.dataset.loaded) {
        content.innerHTML = '<p class="size-guide-drawer__loading">Loading…</p>';
        fetchSizeGuideContent().then((html) => {
          content.innerHTML = html;
          content.dataset.loaded = 'true';
        });
      }
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    }

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-size-guide-open]');
      if (trigger) {
        const picker = trigger.closest('variant-picker');
        const dialog = picker && picker.querySelector('[data-size-guide-drawer]');
        if (dialog) openSizeGuideDrawer(dialog);
        return;
      }

      const closeTrigger = event.target.closest('[data-size-guide-close]');
      if (closeTrigger) {
        const dialog = closeTrigger.closest('dialog[data-size-guide-drawer]');
        if (dialog) dialog.close();
        return;
      }

      // Click on the backdrop area of an open dialog closes it
      const openDialog = event.target.closest('dialog[data-size-guide-drawer][open]');
      if (openDialog && event.target === openDialog) {
        openDialog.close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
